export const DEVICE_CALIBRATION_PRE_EXPIRATION_WARNING_DAYS = 90

export const CALIBRATION_EXPLANATION_URLS_BY_LANGUAGE = {
  en: 'https://www.kistler.com/INT/en/why-calibrate-with-kistler/C00000456',
  de: 'https://www.kistler.com/INT/de/why-calibrate-with-kistler/C00000456',
  zh: 'https://www.kistler.com/INT/zh/why-calibrate-with-kistler/C00000456',
}
